import { useAppSelector } from '@/store';
import { selectDraft, selectExternalUsers, selectInternalUsers } from '@/store/selectors/createSix';
import type { CreateSixUser, LocalDraft } from '@/types/create-six.types';

interface UseCreateSixReviewStepState {
  draft: LocalDraft;
  internalUsers: CreateSixUser[];
  externalUsers: CreateSixUser[];
}

interface UseCreateSixReviewStepReturn {
  state: UseCreateSixReviewStepState;
}

export function useCreateSixReviewStep(): UseCreateSixReviewStepReturn {
  const draft = useAppSelector(selectDraft);
  const internalUsers = useAppSelector(selectInternalUsers);
  const externalUsers = useAppSelector(selectExternalUsers);

  return {
    state: {
      draft,
      internalUsers,
      externalUsers,
    },
  };
}
